var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-row',{staticClass:"fill-height justify-center align-center d-flex"},[_c('v-col',{attrs:{"cols":"6"}},[_c('v-card-title',{staticClass:"py-12 black--text text-center justify-center"},[_vm._v(" Refreshing, Please wait... ")]),_c('v-progress-linear',{attrs:{"color":"deep-purple accent-4","indeterminate":"","rounded":"","height":"6"}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }